const map = {
	"./home_checkout_images/2000/doggy2000.webp": 74107,
	"./home_checkout_images/2000/error2000.webp": 87331,
	"./home_checkout_images/2000/hero2000.webp": 7139,
	"./home_checkout_images/320/delivery_collect320.webp": 44822,
	"./home_checkout_images/320/doggy320.webp": 54047,
	"./home_checkout_images/320/error320.webp": 99791,
	"./home_checkout_images/320/hero320.webp": 56445,
	"./map/collect/not_selected.webp": 24749,
	"./map/collect/selected.webp": 92763,
	"./map/delivery/not_selected.webp": 42737,
	"./map/delivery/selected.webp": 91071,
	"./map/printt Now/Not selected.webp": 13291,
	"./map/printt Now/Selected.webp": 75144,
	"./map/students/Selected.webp": 9251,
	"./map/students/not_selected.webp": 13893,
	"./pages/environment/forest.webp": 33576
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18122;